<button class="dgoods-back-button" (click)="onClick()">
    <ng-content></ng-content>
</button>
